import { Mail } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CommunicationTemplatesManager } from "../../templates/CommunicationTemplatesManager";
import { TemplateSystemStatus } from "../../templates/TemplateSystemStatus";

export function CommunicationManager() {
  return (
    <div className="space-y-6">
      <TemplateSystemStatus />

      <Card>
        <CardContent className="pt-6">
          <CommunicationTemplatesManager />
        </CardContent>
      </Card>
    </div>
  );
}